var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4d93dbf4d35836b448b376d65aae12d3ad5769fe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wallet-activity@m1guelpf"]={id:"4d93dbf4d35836b448b376d65aae12d3ad5769fe"};
      